import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import EloButton from '../Button/Button';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Button = function Button(_ref) {
  var dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    icon = _ref.icon,
    label = _ref.label,
    minimal = _ref.minimal,
    onClick = _ref.onClick,
    secondary = _ref.secondary,
    tooltipTitle = _ref.tooltipTitle,
    tooltipPosition = _ref.tooltipPosition,
    iconDirection = _ref.iconDirection;
  var isMobile = useMediaQuery({
    query: theme.breakpoints.mobile
  });
  return ___EmotionJSX("div", null, ___EmotionJSX(EloButton, {
    dataTestId: dataTestId,
    disabled: disabled,
    icon: icon,
    minimal: minimal,
    onClick: onClick,
    secondary: secondary,
    tooltipTitle: tooltipTitle,
    tooltipPosition: tooltipPosition,
    isMobile: isMobile,
    iconDirection: iconDirection
  }, !isMobile && label));
};
Button.propTypes = {
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  label: PropTypes.string,
  minimal: PropTypes.bool,
  onClick: PropTypes.func,
  secondary: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  tooltipPosition: PropTypes.string,
  iconDirection: PropTypes.string
};
export default Button;